import { useCallback, useState } from "react";
import { useWindowDimensions } from "react-native";

const COLLAPSE_WIDTH = 900;

/**
 * Single source of truth for portal-shell responsive behavior. Below
 * COLLAPSE_WIDTH (900px) the persistent sidebar disappears and the shell
 * relies on a slide-in drawer triggered by a hamburger in the topbar.
 *
 * Each shell (Admin / Client / Judge / Manager) calls this hook once,
 * reads `isMobile` to switch between fixed-sidebar and topbar+drawer
 * layouts, and threads `closeDrawer` into nav-row press handlers so a
 * tap auto-closes the overlay before navigating.
 */
export function useShellResponsive() {
  const { width } = useWindowDimensions();
  const isMobile = width < COLLAPSE_WIDTH;
  const [drawerOpen, setDrawerOpen] = useState(false);

  const openDrawer = useCallback(() => setDrawerOpen(true), []);
  const closeDrawer = useCallback(() => setDrawerOpen(false), []);
  const toggleDrawer = useCallback(() => setDrawerOpen((v) => !v), []);

  return {
    isMobile,
    /** Convenience inverse — handy for `{showSidebar ? <Sidebar /> : null}`. */
    showSidebar: !isMobile,
    drawerOpen: isMobile && drawerOpen,
    openDrawer,
    closeDrawer,
    toggleDrawer,
  };
}
